import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import Flight from "@website/icons/components/flight";
import Hotel from "@website/icons/components/hotel";
import { useCallback, useMemo, useState } from "react";
import { ENDPOINTS } from "../../constants";
import { InstalmentWalletType } from "./index.types";
export const useLandingPage = () => {
  const { isLoggedIn } = useLoginStatus();
  const [isFetching, setIsFetching] = useState(true);
  const [hasError, setHasError] = useState(false);

  const [selectedTab, setSelectedTab] = useState<string>("hotel-domestic");

  const { data, refetch } = useFetcher({
    enabled: isLoggedIn,
    queryKey: ["instalmentWalletData"],
    queryFn: () =>
      fetcher({
        url: ENDPOINTS.INSTALMENT_WALLET,
        method: "GET"
      })
        .then(({ data }: InstalmentWalletType) => {
          setHasError(false);
          return data;
        })
        .catch(() => setHasError(true))
        .finally(() => setIsFetching(false))
  });

  const tabs = useMemo(
    () => [
      {
        title: "رزرو هتل",
        id: "hotel-domestic",
        icon: <Hotel fontSize={24} />
      },
      {
        title: " خرید بلیط پرواز",
        id: "flight-domestic",
        icon: <Flight fontSize={24} />
      }
    ],
    []
  );

  const handleTabItemClick = useCallback((id: string) => {
    setSelectedTab(id);
  }, []);

  return {
    data,
    hasError,
    isFetching,
    refetch,
    tabs,
    handleTabItemClick,
    selectedTab
  };
};
